import { useEffect, useState } from 'react'

/**
 * Subscribe to a CSS media query from React.
 *
 * For layout, a media query in a stylesheet is the better tool. This is for
 * the cases where the *markup* differs between phone and desktop, not just its
 * dimensions — rendering a condensed element rather than a restyled one.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const list = window.matchMedia(query)
    const sync = () => setMatches(list.matches)
    sync()
    list.addEventListener('change', sync)
    return () => list.removeEventListener('change', sync)
  }, [query])

  return matches
}

/** Phone-sized viewport — the same breakpoint the app shell uses. */
export const useIsNarrow = (): boolean => useMediaQuery('(max-width: 768px)')

export default useMediaQuery
